import { EqlFieldValueType, ObjectType } from 'generated/graphql';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';
import { ROOT_UUID } from 'v2/querybuilder/constants/query';
import { QueryBuilderState } from './types';

export const queryBuilderInitialState: QueryBuilderState = {
  query: {
    rootID: ROOT_UUID,
    nodes: {
      [ROOT_UUID]: {
        type: 'group',
        id: ROOT_UUID,
        conjunction: 'AND',
        children: [],
      },
    },
  },
  metadata: {
    isEmpty: true,
    whereClause: EmptyWhereClause,
    hasIncompleteFilters: false,
    hasUnsavedChanges: false,
    isActive: false,
    shouldAutoExecuteOnce: false,
    filterIDUnderInspect: null,
    eqlFieldByFieldID: {
      search: {
        field: {
          field: 'search',
          displayName: 'Text search',
          valueType: EqlFieldValueType.String,
          isMultiValue: true,
          objectType: ObjectType.Feedback,
        },
      },
    },
    shouldFocusExecuteCTA: false,
    error: null,
  },
};
